import state from './state'

const typeStyle = function() {
    let leftIcon = ''
    let backColor = ''
    switch (state.typeMessage) {
        case 'success':
            leftIcon = 'check_circle'
            backColor = 'light-green darken-4'
            break
        case 'warning':
            leftIcon = 'warning'
            backColor = 'orange darken-3'
            break
        case 'info':
            leftIcon = 'info'
            backColor = 'light-blue lighten-1'
            break
        case 'error':
            leftIcon = 'error'
            backColor = 'red darken-4'
            break
        default:
    }
    return { leftIcon: leftIcon, backColor: backColor }
}

export default {
    typeStyle,
}
